import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function sendEnquiry(payload) {
  const { data } = await client.post("/enquiries", payload);
  return data;
}

export default client;
